import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { PageSizes } from "../../common/constants";
import { EntityIdObject } from "../../common/types";
import {
  MarkNotificationsAsSeenRequest,
  NotificationFilterPageRequest,
  NotificationFilterPageResult,
  NotificationSettings,
  UpdateNotificationSettings,
} from "./types";

const GET_NOTIFICATION_SETTINGS = ApiRequestAdapter.create("/notification-settings", HttpMethod.GET);
const UPDATE_NOTIFICATION_SETTINGS = ApiRequestAdapter.create("/notification-settings", HttpMethod.PUT);

const FILTER_NOTIFICATIONS = ApiRequestAdapter.create("/notifications", HttpMethod.GET);
const MARK_ALL_NOTIFICATIONS_AS_SEEN = ApiRequestAdapter.create("/notifications/mark-all-as-seen", HttpMethod.PUT);
const MARK_NOTIFICATIONS_AS_SEEN = ApiRequestAdapter.create("/notifications", HttpMethod.PUT);
const TOGGLE_NOTIFICATION_SENT_AND_SEEN_STATUS = ApiRequestAdapter.create("/notifications/{0}", HttpMethod.PUT);

export const notificationsApi = {
  getNotificationSettings: (): AxiosPromise<NotificationSettings[]> => {
    return apiService.get(GET_NOTIFICATION_SETTINGS.url);
  },
  updateNotificationSettings: (request: UpdateNotificationSettings[]): AxiosPromise<NotificationSettings[]> => {
    return apiService.put(UPDATE_NOTIFICATION_SETTINGS.url, request);
  },
  filterNotifications: (request: NotificationFilterPageRequest): AxiosPromise<NotificationFilterPageResult> => {
    return apiService.get(FILTER_NOTIFICATIONS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  markAllNotificationsAsSeen: (): AxiosPromise<void> => {
    return apiService.put(MARK_ALL_NOTIFICATIONS_AS_SEEN.url);
  },
  markNotificationsAsSeen: (request: MarkNotificationsAsSeenRequest): AxiosPromise<Notification[]> => {
    return apiService.put(MARK_NOTIFICATIONS_AS_SEEN.url, request);
  },
  toggleNotificationSentAndSeenStatus: (request: EntityIdObject): AxiosPromise<Notification> => {
    return apiService.put(TOGGLE_NOTIFICATION_SENT_AND_SEEN_STATUS.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_NOTIFICATIONS_QUERY_PARAMS: Required<NotificationFilterPageRequest> = {
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
  keyword: "",
  onlyUnseen: false,
  topics: [],
  sentAtMin: "",
  sentAtMax: "",
};
